import { mdiVideo } from '@mdi/js'
import Icon from '@mdi/react'
import React from 'react'

const VideoFull = (props) => <Icon path={mdiVideo} size={1} {...props} />

export default React.memo(VideoFull)
